import { createElement } from 'react';
import { Box } from '@alifd/next';
import './index.scss';
const OadpButtonBar = function OadpButtonBar({ style, direction = 'row', justify = 'end', align = 'center', ...otherProps }) {
    return (createElement(Box, Object.assign({ style: style, direction: direction, justify: justify, align: align }, otherProps)));
};
OadpButtonBar.displayName = '按钮栏';
export default OadpButtonBar;
